
// Legal Services Page
import image from 'images/illustrations/finance.png';

export const financial = {
  intro: {
    heading: 'Get your finances in order',
    copy: [
      'Tackle debts and understand your financial opportunities with help from our network of CPAs, financial planners, budget specialists, and licensed securities brokers.',
    ],
  },

  cta: {
    number: '8332106016',
    copy: 'to find the right financial expert',
  },

  iconList: [
    {
      icon: 'message',
      title: 'Get one hour of financial consulting at no cost to you',
      copy: [
        'We’ll connect you with the right financial consultant who can help you tackle debt, set goals, and understand opportunities.',
      ],
    },
  ],

  helpList: [
    'Taxes',
    'Retirement planning',
    'Loans',
    'Debt Management',
    'Identity Theft',
    'Bankruptcy',
    'Saving for college',
    'Budgeting',
    'Child Support',
    'Estate Planning',
  ],
  image,
};



// WEBPACK FOOTER //
// ./client/models/services/financial.js